import { Controller } from "@hotwired/stimulus"

// A button that makes its dialog fill the screen, and remembers the choice for
// the next one: someone who reads documents full screen wants every document
// that way. The dialog carries `dialog-fullscreen` while it is on.
const STORAGE_KEY = "dialog-fullscreen"

export default class extends Controller {
  connect() {
    this.dialog = this.element.closest("dialog")
    this.apply(this.stored())
  }

  toggle() {
    const next = !this.dialog.classList.contains("dialog-fullscreen")
    this.apply(next)
    try {
      window.localStorage.setItem(STORAGE_KEY, next ? "1" : "0")
    } catch (_error) {
      // Private windows and blocked storage: the choice just is not remembered.
    }
  }

  apply(on) {
    if (!this.dialog) return
    this.dialog.classList.toggle("dialog-fullscreen", on)
    this.element.setAttribute("aria-pressed", on ? "true" : "false")
    this.element.title = on ? "Exit full screen" : "Full screen"
    this.element.setAttribute("aria-label", this.element.title)
  }

  stored() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === "1"
    } catch (_error) {
      return false
    }
  }
}
